import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CustomModal from "../../components/CustomModel";
import FormInput from "../../components/GeneralComponents/FormInput";
import {
  List_Account_Appeals_For_Admin,
  Update_Acount_Appeal_Status,
} from "../../DAL/Listing/ActionsHistoy";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";
import { show_proper_words } from "../../utils/constant";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import moment from "moment";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";
import { picBaseUrl } from "../../config/config";

let statusArray = [
  {
    id: "approved",
    name: "Approve",
  },
  {
    id: "rejected",
    name: "Reject",
  },
  {
    id: "need-changes",
    name: "Need Changes",
  },
];

const AppealDisabledAccount = ({ dashboard }) => {
  const { setnavbarTitle, socket } = useAdminContext();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [rowDataID, setRowDataID] = useState("");
  const [rowData, setRowData] = useState({});
  const [loadingButton, setLoadingButton] = useState(false);
  const [status, setStatus] = useState(null);
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [modelState, setModelState] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({
    address: "",
  });

  /**
   * Resets the model and related state variables.
   *
   * - Clears the employee, model state, and status.
   * - Resets the cancel flag and form data (address).
   * - Ensures all relevant state variables are reset when the modal is closed.
   */
  const handleCloseModel = () => {
    setEmployee(null);
    setModelState(false);
    setIsCancel(false);
    setData({
      address: "",
    });
    setStatus(null);
  };

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              style={{
                fill: "#fff",
                marginRight: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setRowData(row);
                setRowDataID(row._id);
                setModelState(true);
              }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "c",
      label: "Created At",
      renderData: (row) => (
        <div>{moment(row?.date_time).format("DD MMM YY hh:mm A")}</div>
      ),
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            setRowData(row);
            setRowDataID(row._id);
            setModelState(true);
          }}
        >
          <div>
            {show_proper_words(
              row?.user_info?.first_name + " " + row?.user_info?.last_name
            ) || "_ _"}
          </div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row.user_info.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "accountName",
      label: "Account",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            setRowData(row);
            setRowDataID(row._id);
            setModelState(true);
          }}
        >
          <div className=" capitalized">{row.account_name || "_ _"}</div>{" "}
          {/* Business Entity Above */}
          <div className="text-muted">{row.email || "_ _"}</div>{" "}
          {/* Business Email Underneath */}
        </div>
      ),
    },
    {
      id: "type",
      label: "Account Type",
      renderData: (row) => <div>{show_proper_words(row.type) || "_ _"}</div>,
    },
    {
      id: "status",
      label: "Appeal Status",
      renderData: (row) => (
        <StatusChip
          status={
            row.status === "need-changes"
              ? show_proper_words(row.status)
              : row.status
          }
          type="activeInactive"
        />
      ),
    },
  ];

  /**
   * Handles the update of an account appeal status.
   *
   * - Validates that a message is provided if the status is not "approved".
   * - Checks if the selected status is different from the current status before proceeding.
   * - Prepares form data with user ID, message, and selected status.
   * - Sends the form data to update the appeal status via `Update_Acount_Appeal_Status`.
   * - Emits a socket event for appeal status update and resets relevant states upon success.
   * - Displays appropriate notifications based on the success or failure of the update.
   */
  const handleUpdateAccountAppealStatus = async (e) => {
    e.preventDefault();

    if (status?.id !== "approved") {
      if (!Data.address) {
        enqueueSnackbar("Please enter message", { variant: "error" });
        return;
      }
    }

    if (status?.id === rowData.status) {
      enqueueSnackbar(
        "The selected status is the same as the current account status.",
        { variant: "warning" }
      );
      return;
    }

    const formData = {
      user_id: employee.id,
      message: Data.address,
      status: status.id,
    };
    if (status.id === "approved") {
      delete formData.message;
    }

    setLoadingButton(true);
    const response = await Update_Acount_Appeal_Status(formData, rowDataID);
    if (response.code === 200) {
      socket.emit("appeal_account_event", {
        notification: response.notification,
      });
      setData({
        address: "",
      });
      setEmployee(null);
      GetAppealAccountList();
      handleCloseModel();
      setLoadingButton(false);
    } else {
      setLoadingButton(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * Fetches the list of account appeals for the admin.
   *
   * - Sends a request to fetch account appeal data for the current page with pagination.
   * - Updates the state with the fetched appeal data, total count, and total pages.
   * - Displays an error notification if the request fails.
   * - Handles loading state during the data fetching process.
   */
  const GetAppealAccountList = async () => {
    setLoading(true);
    const formData = {};
    const response = await List_Account_Appeals_For_Admin(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { list_appeals = [], total_count, total_pages } = response;
      setUserList(list_appeals);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar("Failed to fetch data", { variant: "error" });
    }
  };

  /**
   * Fetches and formats user details based on the search value.
   *
   * - Sends a request to fetch employee data using the provided search value.
   * - Formats the response data by extracting the user ID, name, and email.
   * - Updates the state with the formatted employee data upon successful response.
   * - Displays an error if the response code is not 200 (not shown in this code).
   */
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  useEffect(() => {
    if (!dashboard) {
      setnavbarTitle("Appeal Disabled Account");
    }
    GetAppealAccountList(page, rowsPerPage);
    handleGetDetailUser();
  }, [page, rowsPerPage, location.state?.refresh]);

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="mt-3">
      <CustomTable
        data={userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        is_hide={true}
      />
      <CustomModal
        crossButton={true}
        // CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <>
            <div>
              <h5>Account Details</h5>
            </div>
            <form
              onSubmit={handleUpdateAccountAppealStatus}
              className="form-container pe-2"
            >
              <div>
                <div>
                  <div className="d-flex justify-content-between align-center mt-2">
                    <p className="mb-0">Created At</p>
                    <p className="mb-0">Account Name</p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-1">
                    <p className="mb-0 text-muted">
                      {moment(rowData?.date_time).format("DD MMM YY hh:mm A")}
                    </p>
                    <p className="mb-0 text-muted">{rowData.business_entity}</p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-2">
                    <p className="mb-0">Business Email</p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-1">
                    <p
                      className="mb-0 text-muted"
                      style={{
                        overflowWrap: "anywhere",
                      }}
                    >
                      {rowData.email}
                    </p>
                  </div>
                  <div className="mt-3">
                    <img
                      src={picBaseUrl + rowData?.attachment_url}
                      className="img-fluid"
                    />
                  </div>
                  <hr />
                  <div className="my-3">
                    <SingleSelectAutocomplete
                      inputLabel="Status Changed By"
                      selectedOption={employee}
                      setSelectedOption={setEmployee}
                      optionsList={employeeArray}
                      required={true}
                      name="name"
                      size="medium"
                    />
                  </div>
                  <div className="my-3">
                    <SingleSelectAutocomplete
                      inputLabel="Status"
                      selectedOption={status}
                      setSelectedOption={setStatus}
                      optionsList={statusArray}
                      required={true}
                      name="name"
                      size="medium"
                    />
                  </div>
                  {status?.id === "need-changes" ||
                  status?.id === "rejected" ? (
                    <div>
                      <FormInput
                        label="Message"
                        name="address"
                        type="text"
                        multline={true}
                        required={true}
                        value={Data.address}
                        onChange={(e) =>
                          setData({ ...Data, address: e.target.value })
                        }
                      />
                    </div>
                  ) : null}
                  <div className="col-12 text-end mt-3">
                    {/* Only show the Approve/Reject button when needed */}
                    <Tooltip
                      title={
                        !employee || !status?.name
                          ? "Need to select all the fields to submit the form"
                          : ""
                      }
                    >
                      <span>
                        <Button
                          variant="contained"
                          className="ms-3"
                          disabled={!employee || loadingButton || !status?.name}
                          type="submit"
                        >
                          {loadingButton ? "Loading..." : "Submit"}
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </form>
          </>
        }
      />
    </div>
  );
};

export default AppealDisabledAccount;
